import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';
// ------------------ list Product-------
const getRoleDetail = async (id) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.role.list + id);
    return data;
};
const GetPublicRoleDetailQuery = (id) => {
    return useQuery('roleDetail', () => getRoleDetail(id));
};
// ------------------ Update Role-------
const updateRole = async (payload) => {
    const { id, body } = payload;
    return await HTTP_CLIENT.put(Endpiont.role.update + id, body);
};
const UpdateRoleMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(updateRole, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('roleDetail');
            queryClient.invalidateQueries('registeredUser');
            toastMessage('success', 'User Permissions Updated Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
export { GetPublicRoleDetailQuery, UpdateRoleMutation };
